import { Component, inject, input, signal } from '@angular/core';
import {
  BuildingEquipmentFilterDto,
  BuildingEquipmentItemDto,
  BuildingEquipmentService, EquipmentItemDto, TenantMergeDto
} from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import TenantTypeEnum = TenantMergeDto.TenantTypeEnum

@Component({
  standalone: false,
  selector: 'wr-building-tga-overview',
  templateUrl: './building-tga-overview.component.html',
  styleUrl: './building-tga-overview.component.scss'
})
export class BuildingTgaOverviewComponent {

    readonly buildingEquipmentService = inject(BuildingEquipmentService);
    readonly router = inject(Router);
    readonly formBuilder = inject(FormBuilder);

    readonly buildingId = input.required<string | null>();

    readonly loadTgas = (filter: BuildingEquipmentFilterDto) => this.buildingEquipmentService.findAll(this.prepareTgaFilter(filter));
    readonly getTgaCount = (filter: BuildingEquipmentFilterDto) => this.buildingEquipmentService.getCount(this.prepareTgaFilter(filter));

    tgaListFilterForm!: FormGroup;

    constructor() {
      this.tgaListFilterForm = this.formBuilder.group({
        text: this.formBuilder.control(''),
        creatorTenantId: this.formBuilder.control(''),
        equipmentId: this.formBuilder.control(''),
        equipment: this.formBuilder.control(undefined),
      });

      this.tgaListFilterForm.get('equipment')?.valueChanges.subscribe((equipment: EquipmentItemDto) => {
        this.tgaListFilterForm.get('equipmentId')?.setValue(equipment?.id);
      });
    }

    readonly prepareTgaFilter = (filter: BuildingEquipmentFilterDto) => {
      const buildingId = this.buildingId();
      if (buildingId) {
        filter.buildingId = buildingId;
      }
      return filter;
    };

    navigateToTga(entry: BuildingEquipmentItemDto): void {
      this.router.navigate(['buildingEquipment', entry.id]);
    }

    protected readonly signal = signal;

  protected readonly TenantTypeEnum = TenantTypeEnum;
}
